import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ViewUI from 'view-design'

import enLocale from './en.json'
import zhLocale from './zh.json'
import koLocale from './kor.json'
import deLocale from './de.json'
import nlLocale from './nl.json'
import ptLocale from './pt.json'
import frLocale from './fr.json'
import ruLocale from './ru.json'
import itLocale from './it.json'
import esLocale from './es.json'
import plLocale from './pl.json'
import svLocale from './sv.json'
import zhTwLocale from './zh-tw.json'
import viLocale from './vi.json'
import iviewEn from 'view-design/dist/locale/en-US'
import iviewZh from 'view-design/dist/locale/zh-CN'
import iviewKo from 'view-design/dist/locale/ko-KR'
import iviewNl from 'view-design/dist/locale/nl-NL'
import iviewPt from 'view-design/dist/locale/pt-BR'
import iviewDe from 'view-design/dist/locale/de-DE'
import iviewFr from 'view-design/dist/locale/fr-FR'
import iviewRu from 'view-design/dist/locale/ru-RU'
import iviewIt from 'view-design/dist/locale/it-IT'
import iviewEs from 'view-design/dist/locale/es-ES'
import iviewPl from 'view-design/dist/locale/pl-PL'
import iviewSv from 'view-design/dist/locale/sv-SE'
import iviewZhTw from 'view-design/dist/locale/zh-TW'
import iviewVi from 'view-design/dist/locale/vi-VN'
import { i18nChangeLanguage } from '@wangeditor/editor'
Vue.use(VueI18n)

// 与 Flutter language_select_page、LanguageSwitch 展示顺序一致
const SUPPORTED_LOCALES = ['zh-cn', 'zh-tw', 'en-us', 'ko-kr', 'de-de', 'nl-nl', 'pt-br', 'fr-fr', 'ru-ru', 'it-it', 'es-es', 'pl-pl', 'sv-se', 'vi-vn']

function normalizeLocale (raw) {
  if (!raw || typeof raw !== 'string') return 'zh-cn'
  const x = raw.toLowerCase().replace(/_/g, '-')
  if (SUPPORTED_LOCALES.includes(x)) return x
  if (x === 'zh-tw' || x === 'zh-hk' || x === 'zh-hant') return 'zh-tw'
  if (x.startsWith('zh')) return 'zh-cn'
  if (x.startsWith('en')) return 'en-us'
  if (x.startsWith('ko')) return 'ko-kr'
  if (x.startsWith('de')) return 'de-de'
  if (x.startsWith('nl')) return 'nl-nl'
  if (x.startsWith('pt')) return 'pt-br'
  if (x.startsWith('ja')) return 'en-us'
  if (x.startsWith('fr')) return 'fr-fr'
  if (x.startsWith('ru')) return 'ru-ru'
  if (x.startsWith('it')) return 'it-it'
  if (x.startsWith('es')) return 'es-es'
  if (x.startsWith('pl')) return 'pl-pl'
  if (x.startsWith('sv')) return 'sv-se'
  if (x.startsWith('vi')) return 'vi-vn'
  return 'zh-cn'
}

// 自动检测浏览器语言
let defaultLang = normalizeLocale(navigator.language || 'zh-cn')

// 从localStorage获取语言设置，如果没有则使用默认语言
const currentLang = normalizeLocale(localStorage.getItem('language') || defaultLang)
if (localStorage.getItem('language') && normalizeLocale(localStorage.getItem('language')) !== localStorage.getItem('language')) {
  localStorage.setItem('language', currentLang)
}

const wangeditorLangMap = {
  'zh-cn': 'zh-CN',
  'en-us': 'en-us',
  'ko-kr': 'ko-kr',
  'de-de': 'en',
  'nl-nl': 'en',
  'pt-br': 'en',
  'fr-fr': 'en',
  'ru-ru': 'en',
  'it-it': 'en',
  'es-es': 'en',
  'pl-pl': 'en',
  'sv-se': 'en',
  'zh-tw': 'zh-TW',
  'vi-vn': 'vi-VN'
}
i18nChangeLanguage(wangeditorLangMap[currentLang] || 'en')

const i18n = new VueI18n({
  locale: currentLang,
  fallbackLocale: 'zh-cn',
  messages: {
    'en-us': {
      ...iviewEn,
      ...enLocale
    },
    'zh-cn': {
      ...iviewZh,
      ...zhLocale
    },
    'ko-kr': {
      ...iviewKo,
      ...koLocale
    },
    'de-de': {
      ...iviewDe,
      ...deLocale
    },
    'nl-nl': {
      ...iviewNl,
      ...nlLocale
    },
    'pt-br': {
      ...iviewPt,
      ...ptLocale
    },
    'fr-fr': {
      ...iviewFr,
      ...frLocale
    },
    'ru-ru': {
      ...iviewRu,
      ...ruLocale
    },
    'it-it': {
      ...iviewIt,
      ...itLocale
    },
    'es-es': {
      ...iviewEs,
      ...esLocale
    },
    'pl-pl': {
      ...iviewPl,
      ...plLocale
    },
    'sv-se': {
      ...iviewSv,
      ...svLocale
    },
    'zh-tw': {
      ...iviewZhTw,
      ...zhTwLocale
    },
    'vi-vn': {
      ...iviewVi,
      ...viLocale
    }
  }
})

// 配置iview的国际化
Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
})

// 导出i18n实例和切换语言的方法
export default i18n

// 切换语言
export function setLanguage (lang) {
  const normalized = normalizeLocale(lang)
  localStorage.setItem('language', normalized)
  return true
}

export { normalizeLocale, SUPPORTED_LOCALES }



// WEBPACK FOOTER //
// ./src/lang/i18n.js